<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="申请单号" class="EL-Form-Item">
                        <el-input v-model="pagination.samCode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="pagination.orderCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="pagination.matCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="pagination.matName" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="申请部门" class="EL-Form-Item">
                        <el-input v-model="pagination.section" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                 <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="申请人员" class="EL-Form-Item" v-if="pagination.person == ''">
                        <el-input v-model="pagination.person" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="单据状态" class="EL-Form-Item">
                        <el-select v-model="pagination.status">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待审批" value="10"></el-option>
                            <el-option label="审批完成" value="20"></el-option>
                            <el-option label="待拣配" value="30"></el-option>
                            <el-option label="拣配中" value="40"></el-option>
                            <el-option label="拣配完成" value="50"></el-option>
                            <el-option label="出库完成" value="60"></el-option>
                            <el-option label="关闭" value="70"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="需求时间" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.requireDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.requireDate[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.requireDate[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="领用申请报表">
                <el-button v-authority="'BACK_MENU7_M9_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <el-table-column label="申请单号" prop="samCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="需求数量" prop="matQuan" align="center">
                </el-table-column>
                <!-- <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column> -->
                <el-table-column label="申请人员" prop="person" align="center">
                </el-table-column>
                <el-table-column label="申请部门" prop="section" align="center">
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == '10'">待审批</div>
                        <div v-if="scope.row.status == '20'">审批完成</div>
                        <div v-if="scope.row.status == '30'">待拣配</div>
                        <div v-if="scope.row.status == '40'">拣配中</div>
                        <div v-if="scope.row.status == '50'">拣配完成</div>
                        <div v-if="scope.row.status == '60'">出库完成</div>
                        <div v-if="scope.row.status == '70'">关闭</div>
                    </template>
                </el-table-column>
                <el-table-column label="申请时间" prop="createTime" palign="center">
                </el-table-column>
                <el-table-column label="需求时间" prop="requireDate" align="center">
                </el-table-column>
                <el-table-column label="审批状态" prop="checkFlag" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkFlag == '10'">通过</div>
                        <div v-if="scope.row.checkFlag == '20'">不通过</div>
                    </template>
                </el-table-column>
                <el-table-column label="审批不通过原因" prop="checkMessage" align="center">
                </el-table-column>
            </h-table>
        </box>
    </div>
</template>

<script>
    export default {
        name: "AuxiMaterial",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    samCode: "",
                    matCode: "",
                    matName: "",
                    section: "",
                    person: localStorage.getItem("user"),
                    orderCode: "",
                    status: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
                },

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[0]) {
                            return time.getTime() < new Date(_this.pagination.requireDate[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[1]) {
                            return time.getTime() > new Date(_this.pagination.requireDate[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/auxiMaterial/getAuxiMaterialData",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum || null,
                            pageSize: this.pagination.pageSize || null,
                            samCode: this.pagination.samCode || null,
                            matCode: this.pagination.matCode || null,
                            matName: this.pagination.matName || null,
                            section: this.pagination.section || null,
                            // person: this.pagination.person || null,
                            orderCode: this.pagination.orderCode || null,
                            status: this.pagination.status || null,
                            // requireDate: this.pagination.requireDate || null,
                            beginTime: this.pagination.requireDate[0] || null,
                            endTime: this.pagination.requireDate[1] || null,
                            fcCode: this.pagination.fcCode || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    samCode: "",
                    matCode: "",
                    matName: "",
                    section: "",
                    person: localStorage.getItem("user"),
                    orderCode: "",
                    status: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
                };
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    samCode: this.pagination.samCode || null,
                    matCode: this.pagination.matCode || null,
                    matName: this.pagination.matName || null,
                    section: this.pagination.section || null,
                    // person: this.pagination.person || null,
                    orderCode: this.pagination.orderCode || null,
                    status: this.pagination.status || null,
                    // requireDate: this.pagination.requireDate || null,
                    beginTime: this.pagination.requireDate[0] || null,
                    endTime: this.pagination.requireDate[1] || null,
                    fcCode: this.pagination.fcCode || null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/auxiMaterial/getAuxiMaterialData',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.status == '10') {
                            c['status'] = '待审批'
                        } else if (c.status == '20') {
                            c['status'] = '审批完成'
                        } else if (c.status == '30') {
                            c['status'] = '待拣配'
                        } else if (c.status == '40') {
                            c['status'] = '拣配中'
                        } else if (c.status == '50') {
                            c['status'] = '拣配完成'
                        } else if (c.status == '60') {
                            c['status'] = '出库完成'
                        } else if (c.status == '70') {
                            c['status'] = '关闭'
                        }

                        if (c.checkFlag == '10') {
                            c['checkFlag'] = '通过'
                        } else if (c.checkFlag == '20') {
                            c['checkFlag'] = '不通过'
                        }
                    })
                    const tHeader = ['申请单号', '物料编号', '物料描述', '需求数量', '申请人员', '部门', '状态', '申请时间', '需求时间', '审批状态', '审批不通过原因']
                    const filterVal = ['samCode', 'matCode', 'matName', 'matQuan', 'person', 'section', 'status', 'createTime', 'requireDate', 'checkFlag', 'checkMessage']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '领用申请报表数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_warehouse：导出领用申请报表数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "领用申请查询",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },

        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>